import api from "../services/api";

// Contact API functions
export const submitContactRequest = async (contactData) => {
  return api.post("/api/settings/contact", contactData);
};

export const getContactRequests = async (limit = 50, offset = 0) => {
  return api.get(`/api/settings/contact`, {
    params: { limit, offset },
  });
};

// Feedback API functions
export const submitFeedback = async (feedbackData) => {
  return api.post("/api/settings/feedback", feedbackData);
};

export const getFeedback = async (limit = 50, offset = 0) => {
  return api.get(`/api/settings/feedback`, {
    params: { limit, offset },
  });
};

// Account-level timezone (display preference).
// The server stores everything in UTC; this value is used only for rendering.
export const getAccountTimezone = async () => {
  return api.get(`/api/settings/timezone`);
};

export const updateAccountTimezone = async (timezone) => {
  return api.put(`/api/settings/timezone`, { timezone });
};
